import React from "react";
import Sidebar from "../Layout/Sidebar";
import { Outlet } from "react-router-dom";

const Layout = () => {
	return (
		<div className="flex h-screen">
			{/* Sidebar */}
			<Sidebar />

			{/* Main Section */}
			<div className="flex-1 mt-4 flex flex-col pt-[80px]">
				{/* Main content area */}
				<main className="flex-1 overflow-y-auto pb-6">
					<Outlet />
				</main>
			</div>
		</div>
	);
};

export default Layout;
